import { Link } from "react-router-dom";
import type { ArticleBlock } from "../../content/types";
import { parseArticleText } from "../../news/posts";

/** Article text with its [text](address) links. Everything is rendered as text, never as HTML. */
export function ArticleText({ text }: { text: string }) {
  return (
    <>
      {parseArticleText(text).map((segment, index) => {
        if (!("href" in segment)) return segment.text;
        return segment.internal ? (
          <Link key={index} to={segment.href}>{segment.text}</Link>
        ) : (
          <a key={index} href={segment.href} target="_blank" rel="noopener noreferrer">{segment.text}</a>
        );
      })}
    </>
  );
}

export default function ArticleBody({ blocks }: { blocks: ArticleBlock[] }) {
  return (
    <div className="nw-body">
      {blocks.map((block, index) => {
        if (typeof block === "string") return <p key={index}><ArticleText text={block} /></p>;
        if ("heading" in block) return <h2 key={index}>{block.heading}</h2>;
        if ("list" in block) {
          const List = block.ordered ? "ol" : "ul";
          return (
            <List key={index}>
              {block.list.map((item, i) => <li key={i}><ArticleText text={item} /></li>)}
            </List>
          );
        }
        return (
          <blockquote key={index}>
            <p><ArticleText text={block.quote} /></p>
            {block.cite && <cite>{block.cite}</cite>}
          </blockquote>
        );
      })}
    </div>
  );
}
